import { BridgeComponent } from "@hotwired/hotwire-native-bridge";

// Connects to data-controller="resumin--bridge--event-tracking"
// このコンポーネントは、HotwireNativeで実装したアプリのみ動作します。
// Bridgeコンポーネントからアプリに対して、イベントトラッキング情報を送信します。
//
// クリック時に送信:
//   <button data-controller="resumin--bridge--event-tracking"
//           data-resumin--bridge--event-tracking-event-name-value="button_click"
//           data-resumin--bridge--event-tracking-parameters-value='{"button_id":"submit","page":"/home"}'
//           data-action="click->resumin--bridge--event-tracking#track">
//     送信
//   </button>
//
// 画面表示時に自動送信:
//   <div data-controller="resumin--bridge--event-tracking"
//        data-resumin--bridge--event-tracking-event-name-value="page_view"
//        data-resumin--bridge--event-tracking-parameters-value='{"page":"/home"}'
//        data-resumin--bridge--event-tracking-send-on-connect-value="true">
//   </div>
export default class extends BridgeComponent {
  static component = "event-tracking";
  static values = {
    eventName: String,
    parameters: { type: Object, default: {} },
    sendOnConnect: { type: Boolean, default: false },
  };

  connect() {
    super.connect();

    if (this.sendOnConnectValue) {
      this.track();
    }
  }

  track() {
    this.send(
      "event-tracking",
      {
        eventName: this.eventNameValue,
        parameters: this.parametersValue,
      },
      () => {},
    );
  }
}
